// extracted by mini-css-extract-plugin
export default {"styles":"styles___COZRY","uploadContainer":"uploadContainer___YmGdH"};